/**
 * 后端已将 RunningHub https 结果镜像到腾讯云 COS 时，与 image_history / runninghub_feature_history 一致按约 7 天过期；
 * 若某条仍为 RunningHub 短链（镜像失败或未配 COS），列表展示窗口与此对齐，避免误以为仍可长期访问。
 */
export const RUNNINGHUB_OUTPUT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** 以生成时间为准，距离 7 天 COS 保留过期还剩几天（向上取整；已过期为 0） */
export function getRunningHubCosExpiryDaysRemaining(timestamp: number): number {
  const expiresAt = timestamp + RUNNINGHUB_OUTPUT_MAX_AGE_MS;
  const msLeft = expiresAt - Date.now();
  if (msLeft <= 0) return 0;
  return Math.ceil(msLeft / MS_PER_DAY);
}

/** 历史存档上的删除倒计时文案（与中英文界面一致） */
export function formatRunningHubCosExpiryLabel(timestamp: number, lang: 'zh' | 'en'): string {
  const days = getRunningHubCosExpiryDaysRemaining(timestamp);
  if (days <= 0) return lang === 'zh' ? '已到清理时间' : 'Retention ended';
  if (lang === 'zh') return `剩余${days}天删除`;
  return days === 1 ? 'Deletes in 1 day' : `Deletes in ${days} days`;
}

/**
 * 本机「高清放大 / 色调映射」历史列表各自最多保留条数（localStorage 键互不混用）。
 * RunningHub 不限制单日任务量；此上限仅用于控制侧栏列表长度。
 * 结果 URL 以 COS 镜像为主（失败时回退 RunningHub 短链）；体积远小于旧版双 data URL。
 */
export const RUNNINGHUB_LOCAL_HISTORY_MAX_ITEMS = 100;

